export const DAMAGE_TYPES = {
  DAMAGE: "damage",
  DIRT: "dirt",
  OTHER: "other",
};

export const DAMAGE_COLORS = {
  [DAMAGE_TYPES.DAMAGE]: "#EB5757",
  [DAMAGE_TYPES.DIRT]: "#F2C94C",
  [DAMAGE_TYPES.OTHER]: "#2F80ED",
};
